import React from 'react';
import {View, iURL} from 'MWC';
import tpl from './templates/interactive.jsx';
import cookie from '../../helpers/vendor/cookie';

const utmMarks = [
    'utm_manager',
    'utm_source',
    'utm_comment',
    'utm_campaign',
    'utm_medium',
    'utm_term',
    'utm_content'
];

const CPA_PROGRAM_SOURCE = 'CPA',
    REFERAL_PROGRAM_SOURCE = 'REFERAL';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL
        };

        this.crefs = {};
    }

    componentWillReady(resolve) {
        this.utmParams = this.saveUTMParams();
        resolve();
    }

    saveUTMParams() {
        const params = iURL.getSearchParams();
        let result = {};

        if (params.utm_source === REFERAL_PROGRAM_SOURCE) {
            result = this._getUTMMarks(params);
        } else if (params.utm_source === CPA_PROGRAM_SOURCE) {
            result = this._setUTMMarks(params);
            this.props.history.push(this.props.location.pathname);
        } else if (cookie('utm_source') === CPA_PROGRAM_SOURCE) {
            result = this._getUTMMarks();
        }

        return result;
    }

    _getUTMMarks(storage = cookie) {
        const result = {};

        for (const name of utmMarks) {
            if (storage === cookie) {
                result[name] = cookie(name) || '';
            } else {
                result[name] = storage[name] || '';
            }
        }

        return result;
    }

    _setUTMMarks(data = {}) {
        for (const name of utmMarks) {
            if (data[name]) {
                cookie(name, data[name], {expires: 30, path: '/'});
            } else {
                cookie(name, null, {path: '/'});
            }
        }

        return data;
    }

    static displayName = 'Cards';
}
